import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomHelpComponent} from './custom-help.component';
import {CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";


@NgModule({
  declarations: [CustomHelpComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        HelpFormComponent: {
          component: CustomHelpComponent,
        },
      },
    } as CmsConfig),
    I18nModule,

  ]
})
export class CustomHelpComponentModule { }
